import { Component, input } from '@angular/core';
import { CoreModule, OffersType } from '@toevla-webapplications/core';
import { TranslateModule } from '@ngx-translate/core';
import { Offer } from '../../../../services/offers/offer.model';

@Component({
    selector: 'ivva-booking-submitted',
    templateUrl: './booking-submitted.component.html',
    styleUrls: ['./booking-submitted.component.scss'],
    imports: [CoreModule, TranslateModule]
})
export class BookingSubmittedComponent {
	offer = input<Offer>();

	readonly OffersType = OffersType;
}
